var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { useBackgroundContext } from '../BackgroundContext/index.js';
import { ExternalLinkIcon } from '../icons/index.js';
export const LINK_VARIANTS = [
    'inherit',
    'neutral',
    'primary',
    'accent',
];
export const Link = props => {
    const { as, external, variant = 'accent', children, className, disabled = 'false' } = props, rest = __rest(props, ["as", "external", "variant", "children", "className", "disabled"]);
    const Component = as || 'a';
    const { backgroundType } = useBackgroundContext();
    return (React.createElement(Component, Object.assign({ className: twMerge(clsx('cursor-pointer', 'transition duration-100 ease-in-out ', variant === 'inherit' && 'hover:text-actionAccentHover-500', variant === 'neutral' && [
            backgroundType === 'main' &&
                'text-basicMain-600 hover:text-actionAccentHover-500',
            backgroundType === 'surface' &&
                'text-basicSurface-600 hover:text-actionAccentHover-500',
            backgroundType === 'secondary' &&
                'text-basicSecondary-600 hover:text-basicSecondary-800',
        ], variant === 'primary' &&
            'text-actionPrimary-600 hover:text-actionPrimary-500', variant === 'accent' &&
            'text-actionAccent-600 hover:text-actionAccentHover-500', className, disabled === true && 'pointer-events-none opacity-50')), target: external ? '_blank' : undefined, rel: external ? 'noopener noreferrer' : undefined }, rest),
        children,
        external && (React.createElement(ExternalLinkIcon, { className: "inline-block align-text-bottom ml-1" }))));
};
//# sourceMappingURL=Link.js.map